import { alertService } from 'components/Varios/alert_service';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Row, Col, Table, Input } from "reactstrap";
import { Tab, Tabs } from 'react-bootstrap';
import { GuardarPlanificacionParcialmente, GuardarPlanificacionUnidadHE, ObtenerInformacionModificadaPlanificacionHE, ObtenerInformacionPlanificacionHE, ObtenerReporteExcelResumenPlanificacion, ObtenerVistaPreviaFormularioPlanificacionHE, SolicitarReversoPlanificacion } from './FunctionsPlanificacionHE';
import { DetalleActividadPlanHEDTO, DetalleModificacionPlanificacionHE, DetallePlanificacionHE, DetalleServidoresPlanificacionHE, InformacionAprobadoresHEDTO, InformacionAprobadorHEDTONovedad } from "./TypesPlanificacionHE";
import Cargando from 'components/Varios/Cargando';
import CardRegimenHE from './CardRegimenHE';

import "../../../../assets/scss/Horas Extras/PlanificacionHorasExtras.scss"
import ServidoresPlanificacionHE from './ServidoresPlanificacionHE';
import ActividadPlanificacionHE from './ActividadPlanificacionHE';

import  SaveSVG  from "./../../../../assets/icons/HorasExtras/Guardar.svg"
import  ExitoSVG  from "./../../../../assets/icons/HorasExtras/Exitosa.svg"
import  ErrorSVG  from "./../../../../assets/icons/HorasExtras/Error.svg"

import Swal from 'sweetalert2'
import ModalConfirmacionNew from 'components/Varios/Modals/ModalConfirmacionNew';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ModalReversoHE from 'components/Varios/Modals/ModalReversoHE';
import ModalFirmarPDF from 'components/Varios/Modals/ModalFirmarPDF';
import TabOtrasUnidadesPlan from './TabOtrasUndadesPlan';
import { useHistory, useLocation } from 'react-router';
import AlertEstadoHE from 'components/Varios/AlertEstadoHE';
import { classNameIconoFlechaRegresar } from 'constants/Icons-Font-Awesome';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalCargando from 'components/Varios/ModalCargando';

type ModalConfirmacionPlanificacion = {
    showModal: boolean,
    solicitud: DetalleServidoresPlanificacionHE[],
    content: HTMLElement | undefined
}

type ModalGuardarPlanificacion  = {
    url: string,
    cargando: boolean,
    showModal: boolean,
    solicitud: DetalleServidoresPlanificacionHE[],
    content: HTMLElement | undefined
}

interface LocationState {
    anio?: number;
    numeroMes?: number;
    puedeRealizarAccion?: boolean;
}

export default function PlanificacionHE() {
    const defaultInformacionAprobador: InformacionAprobadoresHEDTO = {
        nombres: '',
        apellidos: '',
        email: '',
        idpersona: 0,
        tipoAprobador: -1,
        TipoAprobadorString: '',
        idEstructuraOrganica: 0,
        idEstructuraOrganicaAprobacion: 0,
    };

    const defaultInformacionAprobadorNovedad: InformacionAprobadorHEDTONovedad = {
        informacionAprobador: defaultInformacionAprobador,
        mensaje: ''
        
    };

    var defaultPlanificacion: DetallePlanificacionHE = { 
        puedeRealizarAccion: false,
        anio: 0,
        mes: 0,
        nombreMes: "",
        diaMax: 0,
        fechaMaxima: new Date(),
        gruposActividad: [],
        listadoServidores: [],
        listadoServidoresOtrasUnidades: [],
        listadoRegimenLaborales: [],
        listadoRegimenLaboralesPlan:[],
        paramsHorasMesPlanificacionHE: [],
        novedadesServidores: [],
        detalleActividadPlanHEDTOs: [],
        informacionAprobador: defaultInformacionAprobadorNovedad,
        idPlanifUnidad: 0,
        refPlanifUnidad: "",
        idSolReverso: 0,
        estadoPlanificacion: "",
        nombreUnidadAprobacion: ""
    }


    const defaultStateModalConfirmacionPlanificacion = {
        showModal: false,
        solicitud: [],
        content: undefined
    }

    const defaultStateInformacionModalGuardarPlanificacion: ModalGuardarPlanificacion = {
        url: "",
        cargando: false,
        solicitud: [],
        showModal: false,
        content: undefined
    }

    const defaultStateModalSolicitarReverso = {
        cargando: false,
        idPlanificacionUnidad: -1,
        observacion: ""
    }

    const location = useLocation();
    const { anio, numeroMes, puedeRealizarAccion } = (location.state as LocationState) || {};


    const [informacionGeneralPlanificacion, setinformacionGeneralPlanificacion] = useState<DetallePlanificacionHE>(defaultPlanificacion);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [loading, setloading] = useState<boolean>(false)

    const [stateinformacionModalGuardarPlanificacion, setstateinformacionModalGuardarPlanificacion] = useState<ModalGuardarPlanificacion>(defaultStateInformacionModalGuardarPlanificacion)

    const [modalConfirmacionPlanificacion, setModalConfirmacionPlanificacion] = useState<ModalConfirmacionPlanificacion>(defaultStateModalConfirmacionPlanificacion);
    const [stateModalSolicitarReverso, setstateModalSolicitarReverso] = useState(defaultStateModalSolicitarReverso)

    const [actividadSeleccionada, setActividadSeleccionada] = useState<DetalleActividadPlanHEDTO | undefined>(undefined);
    const [observacion, setObservacion] = useState("")

    const [loadingAccion, setloadingAccion] = useState<boolean>(false)
    const [generandoReporte, setgenerandoReporte] = useState<boolean>(false)

    const [activeTab, setActiveTab] = useState<string | null>('Actividades');

    const history = useHistory();

    /*useEffect(() => {
        const { state } = location;

        

        // Validar si los datos existen en el state
        if (!state || !state.anio || !state.numeroMes || !state.puedeRealizarAccion) {
            // Si no están los datos requeridos, redirigir a la página deseada
            history.push('/directivo/planificacionHorasExtras');
        }
    }, [history, location]);*/

    
    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error", 
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    
    async function ObtenerInformacionGeneral() {
        setloading(true)

        const anioNormalized = anio??0
        const numeroMesNormalized = numeroMes??0
        const puedeRealizarAccionNormalized = puedeRealizarAccion??false

        const informacionGeneral = await ObtenerInformacionPlanificacionHE(anioNormalized, numeroMesNormalized, puedeRealizarAccionNormalized);
        
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse ) {
            
            if(typeof informacionGeneral.dataResponse !== 'string') {
                setinformacionGeneralPlanificacion(informacionGeneral.dataResponse)
                setActividadSeleccionada(undefined)
                setErrorMessage(null);
            }
            else {  
                
                setinformacionGeneralPlanificacion(defaultPlanificacion); // Set an empty state
                setErrorMessage(informacionGeneral.dataResponse); // Set the error message
                
                showAlert(informacionGeneral.dataResponse,ErrorSVG,false)
                 
            }
            
        } else {
            setinformacionGeneralPlanificacion(defaultPlanificacion); // Set an empty state
            //setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); 
            showAlert(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.dataResponse : 'Error desconocido',ErrorSVG,false)
        }
        setloading(false)
    }

    // useEffect(() => {
    //     //const { anio, numeroMes, puedeRealizarAccion } = (location.state as LocationState) || {};

    //     const { state } = location;
    //     const { anio, numeroMes, puedeRealizarAccion } = (state as LocationState|undefined) || {};

    //     if (!state || !anio || !numeroMes) {
    //         history.push('/directivo/planificacionHorasExtras');
    //         return; 
    //     } else{
    //         ObtenerInformacionGeneral();
    //     }
        
    //     return () => {
    //         alertService.clear();
    //     };
    // }, [history, location]); 

    


    const recargarInformacion = useCallback(async () => {
        setloading(true);
        const anioNormalized = anio??0
        const numeroMesNormalized = numeroMes??0
        const puedeRealizarAccionNormalized = puedeRealizarAccion??false
        const informacionGeneral = await ObtenerInformacionPlanificacionHE(anioNormalized, numeroMesNormalized, puedeRealizarAccionNormalized);
        
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {
            
            setinformacionGeneralPlanificacion(informacionGeneral.dataResponse);
            setActividadSeleccionada(undefined);
            setErrorMessage(null); // Clear any previous error message
            
        } else {
            
            var mensajeError = typeof informacionGeneral.dataResponse === 'string' ? informacionGeneral.dataResponse: informacionGeneral.errorMessage
            mensajeError =mensajeError??"Error desconocido";

            setinformacionGeneralPlanificacion(defaultPlanificacion); // Set an empty state
            setErrorMessage(mensajeError); // Set the error message
            showAlert(mensajeError,ErrorSVG,false)
            //showAlert(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido',ErrorSVG,false) // Show the error alert
        }
        setloading(false);
    }, []);

    useEffect(() => {
        //const { state } = location;
        //const { state } = location;
        //const { anio, numeroMes, puedeRealizarAccion } = (state as LocationState|undefined) || {};

        //if (!state || !anio || !numeroMes) {
        //    history.push('/directivo/planificacionHorasExtras');
        //    return;
        //} else{
        //    recargarInformacion();
        //}
        window.location.href = "https://th.espol.edu.ec/directivo/planificacionhorasextras";
    }, [history, location, recargarInformacion]);



    function GetHTMLPlanificacion(solicitud: DetalleServidoresPlanificacionHE[]): React.ReactNode {  
        // Filtra los servidores con estado "IN"
        const estadosPuedeGuardar = ['','IN','RE', 'MO']

        const filtrados = solicitud.filter(servidor => servidor.estadoplanificacionpersonaunidad !== null && estadosPuedeGuardar.includes(servidor.estadoplanificacionpersonaunidad.trim()));
    
        // Filtra las actividades por estructura y excluye los servidores sin actividades
        const servidoresConActividades = filtrados.map(servidor => {
            const actividadesFiltradas = servidor.actividadesplanificadas
                .filter(act => act.value.idEstructura === informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.idEstructuraOrganicaAprobacion);
            
            return {
                ...servidor,
                actividadesplanificadas: actividadesFiltradas
            };
        }).filter(servidor => servidor.actividadesplanificadas.length > 0); // Excluir servidores sin actividades
    
        const htmlRowsSolicitudes = (
            <>
                <Table responsive bordered className="table_planificacion_he">
                    <thead className="cabeceras_tabla_planificacion_he">
                        <tr className="borde_cabeceras_he">
                            <th>N°</th>
                            <th>Cédula</th>
                            <th>Nombre Completo</th>
                            <th>Actividades</th>
                        </tr>
                    </thead>
                    <tbody>
                        {servidoresConActividades.map((servidor, index) => (
                            <tr key={servidor.idpersona} className={`rows_tabla_planificacion_he ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                <td>{index + 1}</td>
                                <td>{servidor.identificacion}</td>
                                <td>{servidor.nombrescompletos}</td>
                                <td>
                                    {servidor.actividadesplanificadas
                                        .map(act => act.value.nombreActividad) // Mapea a los nombres de actividades
                                        .join(', ')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </>
        );
    
        return htmlRowsSolicitudes;
    }

    const handleSubmit = () => {

        const planificacion = informacionGeneralPlanificacion.listadoServidores;
        const planificacionOtrasUnidades = informacionGeneralPlanificacion.listadoServidoresOtrasUnidades;
        const planificacionCombinada = planificacion.concat(planificacionOtrasUnidades);
        const content: any = GetHTMLPlanificacion(planificacionCombinada)
        setModalConfirmacionPlanificacion(
            { 
                showModal: true,
                solicitud: planificacionCombinada,
                content
            })        
    };

    const handleGuardarPlanificacion = async (planificacion: DetalleServidoresPlanificacionHE[]) => {
        const estadosPuedeGuardar = ['IN','RE','MO']
        const filtradosPlanificacion = planificacion.filter(servidor => servidor.estadoplanificacionpersonaunidad !== null && (estadosPuedeGuardar.includes(servidor.estadoplanificacionpersonaunidad.trim())  ));
        const result = await GuardarPlanificacionParcialmente(filtradosPlanificacion);
        
        if (result.status === 200) {
            showAlert("La planificación se ha guardado correctamente.", ExitoSVG, true);
            setModalConfirmacionPlanificacion(defaultStateModalConfirmacionPlanificacion);
            await recargarInformacion()
            return 1;
        } else {
            showAlert(result.errorMessage, ErrorSVG, true);
            setModalConfirmacionPlanificacion(defaultStateModalConfirmacionPlanificacion);
            await recargarInformacion()
            return -1;
        }
    };

    async function onClickGuardarPlanificacion() {
        const planificacion = informacionGeneralPlanificacion.listadoServidores;
        const planificacionOtrasUnidades = informacionGeneralPlanificacion.listadoServidoresOtrasUnidades;
        const planificacionCombinada = planificacion.concat(planificacionOtrasUnidades);

        const estadosPuedeGuardar = ['','IN','GP','GD', 'RE', 'MO']

        const planificacionFiltrada = planificacionCombinada.filter(item => 
            item.estadoplanificacionpersonaunidad && (estadosPuedeGuardar.includes(item.estadoplanificacionpersonaunidad.trim()))
        );

        setstateinformacionModalGuardarPlanificacion({ ...defaultStateInformacionModalGuardarPlanificacion, cargando: true })

        var respuesta = await ObtenerVistaPreviaFormularioPlanificacionHE(planificacionFiltrada);
        if (respuesta.status === 200) {

            const tituloModal = "Guardar planificación de horas extras"
            setstateinformacionModalGuardarPlanificacion({
                url: respuesta.dataResponse,
                cargando: false,
                solicitud: planificacionFiltrada,
                showModal: true,
                content: undefined
            })
        }
        else {
            setstateinformacionModalGuardarPlanificacion(defaultStateInformacionModalGuardarPlanificacion)
            showAlert(respuesta.errorMessage ?? "No pudo obtenerse la vista previa de Planificación de Horas Extras de la Unidad",ErrorSVG,false)
        }
    }

    async function FirmarDocumentoAutorizar(planificacion: DetalleServidoresPlanificacionHE[], objeto: any) {
        var contrasenia = objeto.contrasenia;
        var filesData = objeto.filesEnviar;

        if (contrasenia && filesData.length > 0) {
            var datosRequest = new FormData();
            datosRequest.append("contrasenia", contrasenia);
            datosRequest.append("idpersona", '0');
            filesData.map((fData) => {
                datosRequest.append("files", fData.file, fData.file.name);
            });
            const planificacionJSON = JSON.stringify(planificacion);
            datosRequest.append("dataServidorSave", planificacionJSON);


            var accionRealizada = await GuardarPlanificacionUnidadHE(datosRequest)
            if (accionRealizada.status === 200) {
                showAlert("La planificación de la unidad se ha firmado y enviado correctamente.", ExitoSVG, true);
                setstateinformacionModalGuardarPlanificacion(defaultStateInformacionModalGuardarPlanificacion)
                await ObtenerInformacionGeneral();
            } else {
                showAlert(accionRealizada.errorMessage, ErrorSVG, true);
                await ObtenerInformacionGeneral();
            }
        }
    }


    const mostrarBotonGuardar = useMemo(() => {
        const tiposValidos: number[] = [0, 2]
        const esAprobadorTipo0 = tiposValidos.includes(informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.tipoAprobador) //&& !informacionGeneralPlanificacion.informacionAprobador.mensaje;        
        const servidoresPlan = informacionGeneralPlanificacion.listadoServidores.find(servidor => servidor.estadoplanificacionpersonaunidad && (servidor.estadoplanificacionpersonaunidad.trim() === 'IN' || servidor.estadoplanificacionpersonaunidad.trim() === 'RE' || servidor.estadoplanificacionpersonaunidad.trim() === 'MO'));
        const servidoresPlanOtrasUnidades = informacionGeneralPlanificacion.listadoServidoresOtrasUnidades.find(servidor => servidor.estadoplanificacionpersonaunidad && servidor.estadoplanificacionpersonaunidad.trim() === 'IN');
        return (servidoresPlan || servidoresPlanOtrasUnidades) && esAprobadorTipo0;
    }, [informacionGeneralPlanificacion.listadoServidores, informacionGeneralPlanificacion.listadoServidoresOtrasUnidades, informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.tipoAprobador]);

    const mostrarBotonFirmarEnviar = useMemo(() => {
        const tiposValidos: number[] = [1, 3]
        const esAprobadorTipo1 = tiposValidos.includes(informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.tipoAprobador) //&& !informacionGeneralPlanificacion.informacionAprobador.mensaje;
        const servidoresPlan = informacionGeneralPlanificacion.listadoServidores.find(servidor => servidor.estadoplanificacionpersonaunidad && (servidor.estadoplanificacionpersonaunidad.trim() === 'IN' || servidor.estadoplanificacionpersonaunidad.trim() === 'GP' || servidor.estadoplanificacionpersonaunidad.trim() === 'RE' || servidor.estadoplanificacionpersonaunidad.trim() === 'MO'));
        const servidoresPlanOtrasUnidades = informacionGeneralPlanificacion.listadoServidoresOtrasUnidades.find(servidor => servidor.estadoplanificacionpersonaunidad && (servidor.estadoplanificacionpersonaunidad.trim() === 'IN' || servidor.estadoplanificacionpersonaunidad.trim() === 'GP' || servidor.estadoplanificacionpersonaunidad.trim() === 'RE'));
        return (servidoresPlan || servidoresPlanOtrasUnidades) && esAprobadorTipo1;
    }, [informacionGeneralPlanificacion.listadoServidores, informacionGeneralPlanificacion.listadoServidoresOtrasUnidades, informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.tipoAprobador]);

    const mostrarBotonSolicitarReverso = useMemo(() => {
        const tiposValidos: number[] = [1, 3]
        const solicitudReverso = informacionGeneralPlanificacion.listadoServidores.find(servidor => servidor.estadoplanificacionpersonaunidad && (servidor.estadoplanificacionpersonaunidad.trim() === 'SR' ))
        const esAprobadorTipo1 = tiposValidos.includes(informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.tipoAprobador) //&& !informacionGeneralPlanificacion.informacionAprobador.mensaje;
        const servidoresPlan = informacionGeneralPlanificacion.listadoServidores.find(servidor => servidor.estadoplanificacionpersonaunidad && (servidor.estadoplanificacionpersonaunidad.trim() === 'ET' ))
        const servidoresPlanOtrasUnidades = informacionGeneralPlanificacion.listadoServidoresOtrasUnidades.find(servidor => servidor.estadoplanificacionpersonaunidad && (servidor.estadoplanificacionpersonaunidad.trim() === 'ET' ))
  
        return (servidoresPlan || servidoresPlanOtrasUnidades) && esAprobadorTipo1;
    }, [informacionGeneralPlanificacion.listadoServidores, informacionGeneralPlanificacion.listadoServidoresOtrasUnidades, informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.tipoAprobador, informacionGeneralPlanificacion.idSolReverso]);
    
    

    const TITULO_PANTALLA = `PLANIFICACIÓN MENSUAL DE HORAS EXTRAS DEL MES ${informacionGeneralPlanificacion.nombreMes.toUpperCase()} DE ${informacionGeneralPlanificacion.anio}`;

    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {informacionGeneralPlanificacion.listadoRegimenLaboralesPlan.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHE
                                regimenLaboralPlan={regimen}
                                index={index}
                                tipo='SOLICITUD'
                                idunidad={informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.idEstructuraOrganicaAprobacion }
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );

    const contenidoTablaServidores = useMemo(() => {
        const contenidoServidores = (
            <ServidoresPlanificacionHE 
                idUnidadAprueba={informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.idEstructuraOrganicaAprobacion}
                listadoServidores={informacionGeneralPlanificacion.listadoServidores}
                recargarInformacion={recargarInformacion}
                paramsHorasMesPlanificacionHE={informacionGeneralPlanificacion.paramsHorasMesPlanificacionHE}
                novedadesServidores={informacionGeneralPlanificacion.novedadesServidores}
                estadoPlanificacion = {informacionGeneralPlanificacion.estadoPlanificacion}
                mensajeNovedad = {informacionGeneralPlanificacion.informacionAprobador.mensaje}
                regimenLaboralesPlan={informacionGeneralPlanificacion.listadoRegimenLaboralesPlan} 
                puedeRealizarAccion ={informacionGeneralPlanificacion.puedeRealizarAccion}
                guardarParcial = {handleSubmit}
                firmaryEnviar = {onClickGuardarPlanificacion}
                solicitarReverso = {handleSolicitarReverso}
                descargarResumenExcel={() => ReporteExcel(informacionGeneralPlanificacion.anio,informacionGeneralPlanificacion.mes)}
                mostrarGuardarParcial = {mostrarBotonGuardar}
                mostrarFirmaryEnviar  = {mostrarBotonFirmarEnviar}
                mostrarSolicitarReverso = {mostrarBotonSolicitarReverso}
                mostrarReporteResumenProyPlanifExcel = {true}
                loadingAccionReporteExcel = {loadingAccion}
                nombreUnidadAprueba={informacionGeneralPlanificacion.nombreUnidadAprobacion}
                gruposActividad = {informacionGeneralPlanificacion.gruposActividad}
                docPlanificacionUnidad = {informacionGeneralPlanificacion.refPlanifUnidad}
                idPlanificacionUnidad = {informacionGeneralPlanificacion.idPlanifUnidad}
            />
        )

        return contenidoServidores;
    }, [informacionGeneralPlanificacion])


    const contenidoOtrasUnidades = useMemo(() => {
        const contenidoServidoresOtrasUnidades = (
            <TabOtrasUnidadesPlan 
                idUnidadAprueba={informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.idEstructuraOrganicaAprobacion}
                listadoServidoresOtrasUnidades={informacionGeneralPlanificacion.listadoServidoresOtrasUnidades}
                recargarInformacion={recargarInformacion}
                paramsHorasMesPlanificacionHE={informacionGeneralPlanificacion.paramsHorasMesPlanificacionHE}
                novedadesServidores={informacionGeneralPlanificacion.novedadesServidores}
                estadoPlanificacion = {informacionGeneralPlanificacion.estadoPlanificacion}
                mensajeNovedad = {informacionGeneralPlanificacion.informacionAprobador.mensaje}
                regimenLaboralesPlan={informacionGeneralPlanificacion.listadoRegimenLaboralesPlan} 
                puedeRealizarAccion ={informacionGeneralPlanificacion.puedeRealizarAccion}
                guardarParcial = {handleSubmit}
                firmaryEnviar = {onClickGuardarPlanificacion}
                solicitarReverso = {handleSolicitarReverso}
                descargarResumenExcel={() => ReporteExcel(informacionGeneralPlanificacion.anio,informacionGeneralPlanificacion.mes)}
                mostrarGuardarParcial = {mostrarBotonGuardar}
                mostrarFirmaryEnviar  = {mostrarBotonFirmarEnviar}
                mostrarSolicitarReverso = {mostrarBotonSolicitarReverso}
                mostrarReporteResumenProyPlanifExcel = {true}
                loadingAccionReporteExcel = {loadingAccion}
                nombreUnidadAprueba={informacionGeneralPlanificacion.nombreUnidadAprobacion}
                gruposActividad = {informacionGeneralPlanificacion.gruposActividad}
                docPlanificacionUnidad = {informacionGeneralPlanificacion.refPlanifUnidad}
                idPlanificacionUnidad = {informacionGeneralPlanificacion.idPlanifUnidad}
            />
        )

        return contenidoServidoresOtrasUnidades;
    }, [informacionGeneralPlanificacion])

    const contenidoActividadesPlan = useMemo(() => {
        const contenidoActividades = (
            <ActividadPlanificacionHE 
                regimenLaborales={informacionGeneralPlanificacion.listadoRegimenLaborales} 
                regimenLaboralesPlan={informacionGeneralPlanificacion.listadoRegimenLaboralesPlan} 
                listadoServidores={informacionGeneralPlanificacion.listadoServidores} 
                recargarInformacion={recargarInformacion} 
                actividadSeleccionadaEditar={actividadSeleccionada} 
                paramsHorasMesPlanificacionHE={informacionGeneralPlanificacion.paramsHorasMesPlanificacionHE}
                detalleActividadPlanHEDTOs={informacionGeneralPlanificacion.detalleActividadPlanHEDTOs}
                idPlanificacionUnidad = {informacionGeneralPlanificacion.idPlanifUnidad}
                docPlanificacionUnidad = {informacionGeneralPlanificacion.refPlanifUnidad}
                idSolicitudReverso = {informacionGeneralPlanificacion.idSolReverso}
                estadoPlanificacion = {informacionGeneralPlanificacion.estadoPlanificacion}
                mensajeNovedad = {informacionGeneralPlanificacion.informacionAprobador.mensaje}
                gruposActividad = {informacionGeneralPlanificacion.gruposActividad}
                idEstructura = {informacionGeneralPlanificacion.informacionAprobador.informacionAprobador.idEstructuraOrganicaAprobacion}
                puedeRealizarAccion ={informacionGeneralPlanificacion.puedeRealizarAccion}
                guardarParcial = {handleSubmit}
                firmaryEnviar = {onClickGuardarPlanificacion}
                solicitarReverso = {handleSolicitarReverso}
                descargarResumenExcel={() => ReporteExcel(informacionGeneralPlanificacion.anio,informacionGeneralPlanificacion.mes)}
                mostrarGuardarParcial = {mostrarBotonGuardar}
                mostrarFirmaryEnviar  = {mostrarBotonFirmarEnviar}
                mostrarSolicitarReverso = {mostrarBotonSolicitarReverso}
                mostrarReporteResumenProyPlanifExcel = {true}
                loadingAccionReporteExcel = {loadingAccion}

            />
            
        )
        return contenidoActividades;
    }, [informacionGeneralPlanificacion, actividadSeleccionada])

    
    function handleSolicitarReverso() {
        const idPlanificacionUnidad = informacionGeneralPlanificacion.idPlanifUnidad
        setstateModalSolicitarReverso({
            cargando: false,
            idPlanificacionUnidad: idPlanificacionUnidad,
            observacion

        })
    }

    async function SolicitarReverso(idPlanificacion, observacion) {
        const respuesta = await SolicitarReversoPlanificacion(idPlanificacion, observacion)
        if (respuesta.status !== 200) {
            showAlert(respuesta.errorMessage, ErrorSVG, true);
            await ObtenerInformacionGeneral();
        }
        else {
            showAlert("Se solicitó el reverso de la planificación correctamente.", ExitoSVG, true);
            await ObtenerInformacionGeneral();
        }
        return 1;
    }


    async function ReporteExcel(anio:number,mes:number) {
        setgenerandoReporte(true)
        await ObtenerReporteExcelResumenPlanificacion(anio,mes)
        setgenerandoReporte(false)
      }

    const handleGoBack = () => {
        history.goBack(); // Esta función te lleva a la URL anterior
    };


    const handleTabChange = (tab: string | null) => {
        setActiveTab(tab); // Actualiza la pestaña seleccionada
    };

    const contenidoModalSolicitarReverso = useMemo(
        () => {
            return (
                <React.Fragment>
                    <Row>
                        <Col xl={12}>
                            <Row>
                                <Col xl={12}>
                                    <span className={"labelReversoUnidadProyeccion"}> Motivo de solicitud de reverso</span>
                                </Col>
                                <Col xl={12}>
                                    <Input
                                        type="textarea"
                                        name="motivoReversoUnidadProy"
                                        id="motivoReversoUnidadProy"
                                        value={observacion}
                                        onChange={(e) => setObservacion(e.target.value)}
                                    />
                                </Col>

                            </Row>
                        </Col>
                    </Row>

                </React.Fragment>

            )
        },
        [observacion],
    )

    return (
        <>
        {loading && <Cargando />}
        {!loading && (
            <div className="content">
                <div className="titulo_seccion"> <i className={`icono-flecha-regresar ${classNameIconoFlechaRegresar}`} onClick={handleGoBack} title='Regresar'></i> {TITULO_PANTALLA}</div>
                
                {errorMessage ? (
                    <></>
                ) : (
                    <> 

                    <Row className="justify-content-end">
                        <Col md="auto">
                            <AlertEstadoHE 
                                estadoPlanificacion={informacionGeneralPlanificacion.estadoPlanificacion.trim()} 
                                oncloseElement={function (): void {;} }
                                closeButton={false}
                                tipo='PL'
                                className="alert-lado-derecho"  // Añadir una clase personalizada si es necesario
                            />
                        </Col>
                    </Row>   
                    {contenidoCardRegimen}
                    
                    <Tabs
                        id="tabPlanificaciones"
                        activeKey={activeTab}
                        className='tab_Planificacion_HE'
                        onSelect={handleTabChange}
                    >                    
                        <Tab
                            eventKey="Actividades" title="PLANIFICAR POR ACTIVIDAD" className='tab_Planificacion_HE'
                        >
                            {loading && <Cargando/>}

                            {!loading && contenidoActividadesPlan}
                        </Tab>
                        <Tab
                            eventKey="Servidores" title="PLANIFICAR POR SERVIDOR" className='tab_Planificacion_HE'
                        >
                            {loading && <Cargando/>}

                            {!loading &&contenidoTablaServidores}
                        </Tab>
                        <Tab
                            eventKey="Otras" title="PLANIFICAR A SERVIDOR DE OTRA UNIDAD" className='tab_Planificacion_HE'
                        >
                            {loading && <Cargando/>}

                            {!loading && contenidoOtrasUnidades}

                        </Tab>
                    </Tabs>                   
                    
                    
                    </>
                )}
                <ModalFirmarPDF
                    show={stateinformacionModalGuardarPlanificacion.url !== "" || stateinformacionModalGuardarPlanificacion.cargando}
                    tituloModal='Guardar Planificación de unidad'
                    admiteFirmaFisica={false}
                    size="xl"
                    urlArchivo={stateinformacionModalGuardarPlanificacion.url}
                    onClose={() => setstateinformacionModalGuardarPlanificacion(defaultStateInformacionModalGuardarPlanificacion)}
                    cargandoDatos={stateinformacionModalGuardarPlanificacion.cargando}
                    onClickFirma={async (objeto) => await FirmarDocumentoAutorizar(stateinformacionModalGuardarPlanificacion.solicitud, objeto)}
                    classNameContentModal='modalBodyVPEmisionCert'
                />

                 <ModalConfirmacionNew
                    show={modalConfirmacionPlanificacion.showModal}
                    size="lg"
                    onClose={() => {
                        setModalConfirmacionPlanificacion(defaultStateModalConfirmacionPlanificacion);
                    }}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={"¿Está seguro/a que desea guardar la siguiente planificación?"}
                    nombreBotonAccion={"Aceptar"}
                    nombreBotonCerrarModal={"Cancelar"}
                    asyncOnClick={async () => await  handleGuardarPlanificacion(modalConfirmacionPlanificacion.solicitud)}
                    contentModal={modalConfirmacionPlanificacion.content}
                    tituloModal={"Guardar planificación"}
                    botonesAccionParteSuperior={true}
                    iconModal={SaveSVG}
                    classNamemensajeConfirmacion={"mensaje-confirmacion"}
                />

                <ModalConfirmacion
                    idModal='ModalReversoUnidadesTHHE'
                    backdrop={false}
                    show={stateModalSolicitarReverso.idPlanificacionUnidad > 0 || stateModalSolicitarReverso.cargando}
                    size='lg'
                    centered={true}
                    asyncAccion={true}
                    asyncClose={false}
                    closeAfterAccion={true}
                    hideBotonCerrar={true}
                    mensajeConfirmacion=''
                    nombreBotonAccion='Aceptar'
                    classNameBotonAccion='btn-primary-new btnAceptarModalReversoTHHE'
                    disabledBotonAccion={!observacion}
                    // <Button  className = "btn-primary-new" color="primary" title="Asignar Servidores" onClick={toggleModal}>Asignar a:</Button>
                    onClose={() => setstateModalSolicitarReverso(defaultStateModalSolicitarReverso)}
                    asyncOnClick={() => SolicitarReverso(stateModalSolicitarReverso.idPlanificacionUnidad, { Observacion: observacion })}
                    contentModal={contenidoModalSolicitarReverso}
                    classNameContentModal='modalContentReversoTHHE'
                    tituloModal={"Solicitar reverso de la planificación de la unidad" }
                    classNametituloModal=''
                />  

                <ModalCargando
                    show = {generandoReporte}
                    size='md'
                    textoCargando='Generando Reporte...'
                    onClose={() => setgenerandoReporte(false)}
                />

                {/* <ModalReversoHE
                    show={stateModalSolicitarReverso.idPlanificacionUnidad > 0 || stateModalSolicitarReverso.cargando}
                    size="lg"
                    onClose={() => setstateModalSolicitarReverso(defaultStateModalSolicitarReverso)}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={"¿Está seguro/a que desea solicitar el reverso de la planificación?"}
                    nombreBotonAccion={"SI"}
                    nombreBotonCerrarModal={"NO"}
                    asyncOnClick={(observacion) => SolicitarReverso(stateModalSolicitarReverso.idPlanificacionUnidad, { Observacion: observacion })}
                    contentModal={undefined}
                    tituloModal={"Solicitar reverso de la planificación de la unidad"}
                    labelObservacion={"Indique el motivo de la solicitud"}
                    botonesAccionParteSuperior={true}
                    classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                    maxLength={500}

                /> */}
            </div>
            
            
        )}
        </>
    )
}